/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListItemGroup_Node = {
    readonly " $fragmentRefs": FragmentRefs<"ListItemNode_Node" | "TypographyNodeName_Node">;
    readonly " $refType": "ListItemGroup_Node";
};
export type ListItemGroup_Node$data = ListItemGroup_Node;
export type ListItemGroup_Node$key = {
    readonly " $data"?: ListItemGroup_Node$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemGroup_Node">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemGroup_Node",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListItemNode_Node"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TypographyNodeName_Node"
        }
      ],
      "type": "Group",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
(node as any).hash = '187bf0ae8919ab473ee175cad7500c6d';
export default node;
